<template>
  <div
    :class="{ hidden: state.hidden }"
    class="navigation"
  >
    <div
      class="main_container"
    >
      <router-link
        :to="{ name: `${ onboardingPart ? 'FaqPageMain' : 'Home' }` }"
        class="navLink"
        :class="{selected: route.meta.navigationTab === 'home', active: route.meta.navigationTab === 'home'}"
      >
        <HeaderHomeIcon
          class="headerIcon"
          :color="route.meta.navigationTab === 'home' ? selectedColor : defaultColor"
        />
        {{ yn('BottomNavigation.Home') }}
      </router-link>

      <router-link
        :to="{ name: `${ onboardingPart ? 'FaqPageMain' : 'CardHolder' }` }"
        class="navLink"
        :class="{selected: route.meta.navigationTab === 'social', active: route.meta.navigationTab === 'social'}"
      >
        <HeaderCardIcon
          class="headerIcon"
          :color="route.meta.navigationTab === 'social' ? selectedColor : defaultColor"
        />
        {{ yn('BottomNavigation.Cardholder') }}
      </router-link>

      <router-link
        :to="{ name: `${ onboardingPart ? 'FaqPageMain' : 'ChatList' }` }"
        class="navLink"
        :class="{selected: route.meta.navigationTab === 'chat', active: route.meta.navigationTab === 'chat'}"
      >
        <HeaderChatIcon
          class="headerIcon"
          :color="route.meta.navigationTab === 'chat' ? selectedColor : defaultColor"
        />
        {{ yn('BottomNavigation.Chat') }}
      </router-link>

      <router-link
        :to="{ name: `${ onboardingPart ? 'FaqPageMain' : 'Profile' }` }"
        class="navLink"
        :class="{selected: route.meta.navigationTab === 'profile', active: route.meta.navigationTab === 'profile'}"
      >
        <HeaderProfileIcon
          class="headerIcon"
          :color="route.meta.navigationTab === 'profile' ? selectedColor : defaultColor"
          :warning="true"
        />
        {{ yn('BottomNavigation.Profile') }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import {useRoute} from 'vue-router'
import HeaderHomeIcon from './BottomAppBarHomeIcon.vue'
import HeaderChatIcon from './BottomAppBarChatIcon.vue'
import HeaderCardIcon from './BottomAppBarCardIcon.vue'
import HeaderProfileIcon from './BottomAppBarProfileIcon.vue'
import { onMounted, onUnmounted, reactive, computed } from 'vue'
import {yn} from '@/locales/i18nextInit.js'
import store from '@/store/store'
import {trackVisualKeyboard} from '@/utils/trackVisualKeyboard.js'

const route = useRoute()

const state = reactive({
  hidden: false,
  // hidden: true,
})

let stopKeyboardTracking = null

const theme = store.state.app.appData?.themes?.find(theme => theme.default)

const selectedColor = theme.styles.app['bar-icon-active-color'] ?? '#FFFFFF'
const defaultColor = theme.styles.app['bar-icon-color'] ?? '#8B8B8B'

const onboardingPart = computed(() => {
  return store.state.user.faqContinuation
})

const moderationStatus = computed(() => {
  return store.getters["user/moderationStatus"]
})

onMounted(() => {
  if (!store.state.user.profile.onboarding_finished) {
    state.hidden = true
    return
  }

  stopKeyboardTracking = trackVisualKeyboard((isOpen) => {
    state.hidden = isOpen
  })
});

onUnmounted(() => {
  stopKeyboardTracking?.()
});

</script>

<style lang="scss">
@import "@/assets/variables";

.navigation {
  border-top: 1px solid var(--app-bar-border-color);
  background: var(--app-bar-color);
  display: flex;
  height: $bottomMenuOffset;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 99;
  flex-shrink: 0;

  .main_container {
    display: flex;
    padding: 12px 0 24px 0;

    & > .navLink {
      flex-basis: 100px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 10px;
      font-weight: 600;
      gap: 6px;
      color: var(--app-bar-icon-color, #8B8B8B);

      &.selected {
        color: var(--app-bar-icon-active-color);
      }
    }
  }
}
</style>
